/* eslint-disable default-case */
/* eslint-disable consistent-return */
import i18next from 'i18next';

import {ReportConfigType} from 'web-app/util/graphql/api-types';

export const ListeningAndAttention = '79c510ca-a7f4-4e28-9014-f19e7177c71d';
export const Understanding = '1ecca0c2-383a-4842-b9f0-966d378c3f44';
export const Speaking = 'eff0cab0-bf69-43c0-bf98-f2e5ebf14a3d';
export const MovingAndHandling = '8cc82a8a-ef83-40b6-bafa-0d23c1a92a14';
export const HealthAndSelfCare = '9572c385-37c2-4b12-bb45-54e6098a679c';
export const SelfConfidence = '8b8d0d4a-1392-4ca5-b282-2423a8d1d501';
export const ManagingFeelings = 'd6ae916f-584e-4457-ac24-69d69703bfd4';
export const MakingRelationships = '72b54ae4-f5ec-4d8d-bde3-e13c671b20b2';
export const Reading = '68cb6dc7-2f15-4550-8bfc-2b4e3af8087a';
export const Writing = 'a7445f56-4cfd-4b13-b131-d829aa1f72c0';
export const Numbers = 'fa94db57-3624-4d63-b4b2-2b1ab176a902';
export const Shape = '250199d6-b841-45d6-8ef8-975ab307f511';
export const PeopleAndCommunities = '9f860fb9-02d7-494a-9c64-7187f97409aa';
export const TheWorld = '5866d8e4-c423-4e4c-9422-935038360375';
export const Technology = '88ff96f5-d687-455a-95e2-090465d45518';
export const ExploringMedia = 'fbfcca7d-0367-4175-891a-8b5f3dccc744';
export const BeingImaginative = 'cd94c17c-5a3c-425e-8553-7098eb11e5d5';

export type EYO_SUB_AREA_ID =
    | typeof ListeningAndAttention
    | typeof Speaking
    | typeof MovingAndHandling
    | typeof HealthAndSelfCare
    | typeof SelfConfidence
    | typeof ManagingFeelings
    | typeof Understanding
    | typeof MakingRelationships
    | typeof Reading
    | typeof Writing
    | typeof Numbers
    | typeof Shape
    | typeof PeopleAndCommunities
    | typeof TheWorld
    | typeof Technology
    | typeof ExploringMedia
    | typeof BeingImaginative;

export const CommunicationAndLanguage = 'd89f16c4-6c0b-4429-b878-6ae14d006363';
export const PhysicalDevelopment = '2a580aa0-5130-416d-958c-b0d2868c1907';
export const PersonalSocialAndEmotional = 'b174f260-cc27-44fe-9714-83125a5b33a6';
export const Literacy = '70b3bcf2-6a0c-4f61-bc86-f0c48938fa07';
export const Mathematics = '0f7c6161-6148-4d29-9ea5-27dd4e81b01c';
export const UnderstandingTheWorld = '80de3941-f410-4df5-befa-9acead822c84';
export const ExpressiveArtsAndDesign = 'b202414a-7763-4a31-9938-a21a96e9b8f2';

export type EYO_AREA_ID =
    | typeof CommunicationAndLanguage
    | typeof PhysicalDevelopment
    | typeof PersonalSocialAndEmotional
    | typeof Literacy
    | typeof Mathematics
    | typeof UnderstandingTheWorld;

export const REFINEMENT_TRACKING = '04e99d72-2dde-11ed-958b-0242ac130009';
export const EYFS_STATEMENT_TRACKING = '2871e338-2c93-494e-8deb-aff74301ba1d';
export const EYFS_REFINEMENT_COUNT = '8086e5e5-e7df-4281-bbc0-f7d2d84f704f';
export const EYFS_STATEMENT_COUNT = 'aa548ec3-ee1b-4805-b320-47630b6932a5';
export const EYFP_STATEMENT_COUNT = '52761bff-ff0b-49ae-8b10-608f1a977c76';
export const EYFP17_STATEMENT_COUNT = '28f74413-f926-4430-8d92-9580532c9255';
export const CFE_STATEMENT_COUNT = '105e2b68-05fe-4b0a-8227-bfb4856b9315';
// Deprecated: Uses the old EYFS framework with statements
export const LEGACY_EYFS_2021_REFINEMENT_COUNT = 'eb400a26-82c8-4179-843b-98e428e6341b';
// Deprecated: Uses the old EYFS framework with statements
export const LEGACY_EYFS_2021_OBSERVATION_COUNT = '3cd9c05f-0bf4-4644-bea1-cf9bb12e2748';
export const EYFS_2021_OBSERVATION_COUNT = '48360dd9-3015-4960-81c1-72501d7563f2';
// eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
export const CFE_STATEMENT_TRACKING_TALLY = '105e2b68-05fe-4b0a-8227-bfb4856b9315';
export const CFE_STATEMENT_TRACKING_PROGRESS_REPORT = '6e797d5e-9f51-4cc2-9ef7-78ba8f71ddae';

export type REPORT_CONFIG =
    | typeof REFINEMENT_TRACKING
    | typeof EYFS_STATEMENT_TRACKING
    | typeof EYFS_REFINEMENT_COUNT
    | typeof EYFS_STATEMENT_COUNT
    | typeof EYFP_STATEMENT_COUNT
    | typeof EYFP17_STATEMENT_COUNT
    | typeof CFE_STATEMENT_COUNT
    | typeof LEGACY_EYFS_2021_REFINEMENT_COUNT
    | typeof LEGACY_EYFS_2021_OBSERVATION_COUNT
    | typeof EYFS_2021_OBSERVATION_COUNT
    | typeof CFE_STATEMENT_TRACKING_TALLY
    | typeof CFE_STATEMENT_TRACKING_PROGRESS_REPORT;

// eslint-disable-next-line no-restricted-syntax
export type REFINEMENT_COMPARE_MODE = 'PROGRESS_AS_OF' | 'COMPARE_DATES' | 'COMPARE_BASELINE';

export const reportConfigToString = (config: REPORT_CONFIG) => {
    switch (config) {
        case REFINEMENT_TRACKING:
            return i18next.t('childDevelopment.refinementTrackingTitle');
        case EYFS_STATEMENT_TRACKING:
            return i18next.t('childDevelopment.statementTrackingTitle');
    }
};

export const EYFS_2021_REPORTS = [LEGACY_EYFS_2021_REFINEMENT_COUNT, LEGACY_EYFS_2021_OBSERVATION_COUNT];

export const ASSESSMENT_SETTINGS_COLORS = [
    {font: '#085491', background: '#BCDFFB'},
    {font: '#402B6E', background: '#D6CCEB'},
    {font: '#1B234B', background: '#8F9AD6'},
    {font: '#0A5C20', background: '#CFE7D5'},
    {font: '#805D00', background: '#FFDC80'},
    {font: '#8B0E38', background: '#F6A2BE'},
    {font: '#4C4A4F', background: '#D8D7DA'},
];

export const reportConfigTypeNameForTracking = (configType: ReportConfigType) => {
    // reportConfigTypeNameForTracking is returned as an untranslated string because it's used in the analytics for event tracking.
    // All configuration type properties need to have a common name, regardless of the language used in the app.
    switch (configType) {
        case ReportConfigType.ADMIN:
            return 'Tally';
        case ReportConfigType.PROGRESS:
            return 'Progress report';
        default:
            return configType;
    }
};

export const MAX_ACTIVITIES = 50;

export const DEFAULT_CURRICULUM_VERSION = 1;
